export const CATEGORY = {
    'mall_type': 'Store Type',
    'store_size': 'Store Size',
    'mall_category': 'Store Subtype',
    'region': 'Region',
    'product_group': 'Product Category',
    'storeSize': 'Store Size',
    'storeType': 'Store Type',
}

// also using it in Inventory
// FIX ME: Make it common Constant
export const SHORTEN_SALES_COMPANY = {
    7: "SVI",
    2: "SSM",
    142: "SMCO"
}

export const PERIOD_OPTIONS = [
    { label: 'MTD', value: 'mtd' },
    { label: 'YTD', value: 'ytd' }
]

export const STORE_TYPE_OPTIONS = [
    { label: 'Total', value: 'total' },
    { label: 'L4L', value: 'likeforlike' }
]
